<template>
  <section class="side-sec"  :class="{ 'hide' : showSide == false}">
    <div class="side-page">
      <div class="sidebar-main-wrap">
        <div class="sidebar-menu-wrap">
          <ul class="sidebar-menu">
            <li>
              <span :class="{ 'active' : pageType == '전산DB'}">
                <router-link to="/place">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><title>전산 DB</title><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l176 0-10.7 32L160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-69.3 0L336 416l176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM512 64l0 224L64 288 64 64l448 0z"/></svg>
                  <span>전산 DB</span>
                </router-link>
              </span>
            </li>
            <li>
              <span :class="{ 'active' : pageType == '중복DB'}">
                <router-link to="/register">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><title>중복 DB</title><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176L96 176l0 128c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7c0 0 0 0 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128l38.9 0 40 0 40 0c8.8 0 16 7.2 16 16l0 208c0 17.7-14.3 32-32 32l-32 0c-11.8 0-22.2-6.4-27.7-16l-84.9 0c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384l-32 0c-17.7 0-32-14.3-32-32L0 144c0-8.8 7.2-16 16-16l40 0 40 0 19.8 0c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64L259 64c4.4 0 8.9 .2 13.2 .6zM544 320l0-144-48 0c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1l74.8 0zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"/></svg>
                  <span>중복 DB</span>
                </router-link>
              </span>
            </li>
            <li>
              <span :class="{ 'active' : pageType == '수집DB'}">
                <router-link to="/collect">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><title>수집 DB</title><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M448 80l0 48c0 44.2-100.3 80-224 80S0 172.2 0 128L0 80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6L448 288c0 44.2-100.3 80-224 80S0 332.2 0 288L0 186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6l0 85.9c0 44.2-100.3 80-224 80S0 476.2 0 432l0-85.9z"/></svg>
                  <span>수집 DB</span>
                </router-link>
              </span>
            </li>
            <li>
              <span :class="{ 'active' : pageType == '수집DB2'}">
                <router-link to="/collect2">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><title>수집 DB2</title><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M448 80l0 48c0 44.2-100.3 80-224 80S0 172.2 0 128L0 80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6L448 288c0 44.2-100.3 80-224 80S0 332.2 0 288L0 186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6l0 85.9c0 44.2-100.3 80-224 80S0 476.2 0 432l0-85.9z"/></svg>
                  <span>수집 DB2</span>
                </router-link>
              </span>
            </li>
            <li v-if="authStore.grade == 'NORMAL'">
              <span :class="{ 'active' : pageType == 'MyDB'}">
                <router-link to="/myDB">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><title>My DB</title><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"/></svg>
                  <span>My DB</span>
                </router-link>
              </span>
            </li>
            <li v-if="authStore.grade == 'ADMIN'">
              <hr>
              <span :class="{ 'active' : pageType == '회원관리'}">
                <router-link to="/manageUser">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><title>회원 관리</title><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"/></svg>
                  <span>회원 관리</span>
                </router-link>
              </span>
            </li>
            <hr>
            <li>
              <span>
                <router-link to="/logout">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><title>로그아웃</title><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224 384 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l146.7 0-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"/></svg>
                  <span>로그아웃</span>
                </router-link>
              </span>
            </li>
          </ul>
        </div>
        <div class="sidebar-back-wrap">
          <div class="back-btn" @click="toggleSide" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><title>메뉴</title><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>
            <span>메뉴 접기</span>
          </div>
        </div>
      </div>
      <div class="sidebar-hide-logo" @click="toggleSide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/></svg></div>
    </div>
  </section>
</template>
<script>
export default {
  name :"SidePage",
  watch :{
    '$route.name':function(name) {
      this.pageType = name;
    },
  },
  methods : {
    init(){
      switch (this.pageType) {
        case "전산DB":
        case "중복DB":
        case "수집DB":
        case "수집DB2":
        case "MyDB":

          this.showMenu = "place";
          break;
        case "회원관리":
          this.showMenu = "management";
          break;
      }
    },
    toggleSide(){
      this.showSide = !this.showSide;
    }
  },
  data(){
    return {
      showMenu : "",
      pageType:this.$route.name,
      showSide : true,
    };
  },
  created() {
    this.init();
  }
}
</script>
<style scoped>
.side-sec .sidebar-main-wrap {
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: calc(100vh - 80px);
  flex-direction: column;
}
.side-sec .sidebar-main-wrap .sidebar-menu-wrap {
  width:100%;
}
.side-sec .sidebar-main-wrap .sidebar-back-wrap svg {
  width:22px;
}
.side-sec .sidebar-main-wrap .sidebar-back-wrap .back-btn {
  letter-spacing: 0.7px;
  text-transform: capitalize;
  font-weight: 600;
  transition: all 0.3s ease;
  padding: 12px 20px;
  font-size:0.875rem;
  cursor:pointer;
  line-height: 21px;
  display:flex;
  gap:30px;
  align-items: center;
}
.side-sec .logo-wrap .back-btn{
  width:20px;
  display: inline-block;
  cursor:pointer;
}
.side-sec .side-page {
  position: fixed;
  top: 80px;
  z-index: 9;
  height: auto;
  line-height: inherit;
  background: #fafafa;
  width: 200px;
  text-align: left;
  box-shadow: 0 0 21px 0 rgba(89, 102, 122, 0.1);

}
.side-sec.hide .side-page {
  width: auto;
}
.side-sec.hide .sidebar-menu-wrap .sidebar-menu > li > span > a > span,
.side-sec.hide .back-btn > span {
  display:none;
}
.side-sec.hide .back-btn > svg {
  transform: scaleX(-1);
}
.side-sec .sidebar-menu-wrap .sidebar-menu {
  left: -300px;
  z-index: 99;
  transition: color 1s ease;
  overflow: auto;
  color: rgba(0, 0, 0, 0);
}
.side-sec .sidebar-menu-wrap .sidebar-menu hr {
  color:red;
}
.side-sec .sidebar-menu-wrap .sidebar-menu > li > span {
  letter-spacing: 0.7px;
  text-transform: capitalize;
  font-weight: 600;
  transition: all 0.3s ease;
  padding:15px 20px;
  font-size:0.875rem;
  cursor:pointer;
  display:flex;
  line-height: 21px;
  gap:13px;
}
.side-sec .sidebar-menu-wrap .sidebar-menu > li > span.active {
  background-color:#d3edff;
}
.side-sec .sidebar-menu-wrap .sidebar-menu > li > span > a {
  color:#000;
  text-decoration: none;
  display:flex;
  width:100%;
  gap:30px;
  align-items: center;
}
.side-sec .sidebar-menu-wrap .sidebar-menu > li > span > a:hover,
.side-sec .sidebar-menu-wrap .sidebar-menu > li > span.active > a {
  color:#4a90e2;
}
.side-sec .sidebar-menu-wrap .sidebar-menu > li > span > a:hover svg,
.side-sec .sidebar-menu-wrap .sidebar-menu > li > span.active svg {
  fill:#4a90e2;
}
.side-sec .sidebar-menu > li > span svg {
  width:22px;
}
/*
.side-sec .sidebar-menu .sidebar-title {
  font-size: 14px;
  font-weight: 600;
  color: #75758a;
  text-transform: uppercase;
  margin-bottom: 0;
  letter-spacing: 0.4px;
  padding: 25px 0 6px 20px;
  margin-top: 10px;
  position: relative;
}
.side-sec .sidebar-menu .sidebar-title:before {
  position: absolute;
  content: "";
  top: 0;
  left: 50%;
  background: rgba(0, 0, 0, 0.1);
  width: calc(100% - 40px);
  height: 1px;
  transform: translateX(-50%);
}
.side-sec .sidebar-menu .sidebar-title h6 {
  font-size: 14px;
  font-weight: 600;
  color: #75758a;
  text-transform: uppercase;
  margin-bottom: 0;
  letter-spacing: 0.4px;
}
.side-sec .sidebar-menu .sidebar-content {
  display: block;
  width: 100%;
  position: relative;
}
.side-sec .sidebar-menu .sidebar-content > span {
  letter-spacing: 0.7px;
  text-transform: capitalize;
  color: rgba(0, 0, 0, 1);
  font-weight: 900;
  transition: all 0.3s ease;
  padding: 12px 20px;
  font-size: 0.875rem;
  cursor:pointer;
  display: flex;
  line-height: 21px;
  gap: 13px;
}
.side-sec .sidebar-menu .sidebar-content > span i {
  width:15px;
}
.side-sec .sidebar-menu .sidebar-content > span.active{
  position: relative;
  margin-bottom: 10px;
  background-color: #f1f0ff;
  color:#4a90e2;
}
.side-sec .sidebar-menu .sidebar-content > span:hover{
  background-color: #f1f0ff;
  color:#4a90e2;
}
.side-sec .sidebar-menu .sidebar-content > span:hover svg,
.side-sec .sidebar-menu .sidebar-content > span.active svg {
  fill:#4a90e2;
}
.side-sec .sidebar-menu .sidebar-content > span.active::after {
  position: absolute;
  content: "";
  width: 4px;
  height: 35px;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: #4a90e2;
  border-radius: 5px 0px 0px 5px;
}
.side-sec .sidebar-menu .sidebar-submenu {
  max-height: 0;
  overflow: hidden;
  position: relative;
  cursor:pointer;
}
.side-sec .sidebar-menu .sidebar-submenu::before{
  position: absolute;
  content: "";
  width: 1px;
  height: calc(100% - 8px);
  background: rgba(117, 117, 138, 0.4);
  top: -10px;
  left: 27px;
  transition: none;
}
.side-sec .sidebar-menu .sidebar-submenu.show {
  max-height: 900px;
}
.side-sec .sidebar-menu .sidebar-submenu > span {
  padding: 7px 25px 7px 48px;
  font-size: 0.875rem;
  color: rgba(64, 64, 64, 1);
  display: block;
  position: relative;
  letter-spacing: 0.06em;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.side-sec .sidebar-menu .sidebar-submenu > span.active,
.side-sec .sidebar-menu .sidebar-submenu > span:hover,
.side-sec .sidebar-menu .sidebar-submenu > span.active > a,
.side-sec .sidebar-menu .sidebar-submenu a:hover{
  color:#4a90e2;
}
.side-sec .sidebar-menu .sidebar-submenu > span::before {
  position: absolute;
  content: "";
  width: 5px;
  height: 5px;
  top: 50%;
  transform: translateY(-50%);
  left: 25px;
  border-radius: 100%;
  background: #4a90e2;
  opacity: 0;
  visibility: hidden;
  transition: none;
}
.side-sec .sidebar-menu .sidebar-submenu > span.active::before {
  opacity: 1;
  visibility: visible;
}
.side-sec .sidebar-menu .sidebar-submenu > span::after {
  position: absolute;
  content: "";
  top: 48%;
  width: 8px;
  border-top: 1px solid rgba(117, 117, 138, 0.4);
  left: 27px;
  transition: none;
}
.side-sec .sidebar-menu .sidebar-submenu > span > a {
  display: block;
  text-decoration: none;
  color:rgba(64, 64, 64, 1);
}
 */
</style>